import { createAsyncThunk } from '@reduxjs/toolkit';
import callRpc from '~/utils/call-rpc';
import { actions as notificationActions } from '@bufferapp/notifications/lib/reducer';
import type { AppDispatch, RootState } from '~/store';
import {
  PostActionNotificationSuccess,
  PostActionNotificationError,
} from '../types';

export const sharePostNow = createAsyncThunk<
  boolean,
  { postId: string },
  { state: RootState; dispatch: AppDispatch }
>('posts/sharePostNow', async ({ postId }, { dispatch, rejectWithValue }) => {
  try {
    const response = await callRpc('sharePostNow', {
      updateId: postId,
    });

    if (!response.success) {
      throw new Error(response.message);
    }

    dispatch(
      notificationActions.createNotification({
        notificationType: 'success',
        message: PostActionNotificationSuccess.SHARE_NOW,
      })
    );

    return true;
  } catch (error) {
    dispatch(
      notificationActions.createNotification({
        notificationType: 'error',
        message: PostActionNotificationError.SHARE_NOW,
      })
    );

    return rejectWithValue(error.message);
  }
});
